const TAG_COLOR_MAP = {
  volcano: '#ff7a45',
  orange: '#ffa940',
  gold: '#ffc53d',
  green: '#73d13d',
  blue: '#40a9ff',
  purple: '#b37feb',
};

export const DEFAULT_TAG_COLOR = 'blue';

export const resolveTagColor = (color) => {
  if (!color) return TAG_COLOR_MAP[DEFAULT_TAG_COLOR];
  const trimmed = color.trim();
  const normalized = trimmed.toLowerCase();
  return TAG_COLOR_MAP[normalized] || trimmed;
};

export const TAG_COLORS = Object.keys(TAG_COLOR_MAP);

export default TAG_COLOR_MAP;
